import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import { openModal } from 'Helpers/ModalHelper';
import { buildModalQuery } from 'Consts/ModalQueries';
import modalConsts from 'Consts/ModalNames';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import featureEnabled from 'Helpers/Affordances';
import relationships from 'Consts/Relationships';
import { fullDate } from 'Consts/DateFormats';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import _ from 'lodash';
import Goal from './Goal';
import GoalsHeader from './GoalsHeader';


const useStyles = makeStyles(theme => ({
  goals: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const GoalCardList = ({
  loadedGoals,
  onDelete,
}) => {
  const classes = useStyles();
  const { householdResource } = useSimpleHousehold();
  const { eventTrackingNodeRef, logEvent } = useEventTrackingLogEvent();

  const priorityOrder = { high: 1, medium: 2, low: 3 };
  const [activeGoals, completedGoals] = _(loadedGoals)
    .toArray()
    .sortBy(v => priorityOrder[v.attr('priority')])
    .partition(v => v.attr('percentComplete') !== '100' || v.attr('completed') !== 'true')
    .value();
  const goalsPageAndBannerEnabled = featureEnabled(householdResource, relationships.goalsPageAndBanner);
  const ActiveGoals = activeGoals.map((goal) => {
    let formattedEndDate = null;
    if (goal.attr('endDate')) {
      formattedEndDate = moment(goal.attr('endDate')).format(fullDate);
    }
    let subHeader = null;
    if (goalsPageAndBannerEnabled) {
      subHeader = formattedEndDate;
    } else {
      subHeader = `${goal.attr('timeHorizonValue')} ${goal.attr('timeHorizonType')}${goal.attr('timeHorizonValue') > 1 ? 's' : ''}`;
    }
    return (
      <Goal
        key={goal.id()}
        title={goalsPageAndBannerEnabled ? goal.attr('name') : goal.attr('description')}
        subheader={subHeader}
        content={goal.attr('notes')}
        priority={goal.attr('priority')}
        status={goalsPageAndBannerEnabled ? goal.attr('percentComplete') : goal.attr('status')}
        onEdit={() => {
          logEvent('Clicked Edit Goal');
          openModal(buildModalQuery(modalConsts.goalModal, {
            goalId: goal.id(),
          }));
        }}
        onDelete={() => { onDelete(goal); }}
      />
    );
  });
  const CompletedGoals = completedGoals.map((goal) => {
    let formattedEndDate = null;
    if (goal.attr('endDate')) {
      formattedEndDate = moment(goal.attr('endDate')).format(fullDate);
    }
    let subHeader = null;
    if (goalsPageAndBannerEnabled) {
      subHeader = formattedEndDate;
    } else {
      subHeader = `${goal.attr('timeHorizonValue')} ${goal.attr('timeHorizonType')}${goal.attr('timeHorizonValue') > 1 ? 's' : ''}`;
    }
    return (
      <Goal
        key={goal.id()}
        title={goalsPageAndBannerEnabled ? goal.attr('name') : goal.attr('description')}
        subheader={subHeader}
        content={goal.attr('notes')}
        priority={goal.attr('priority')}
        status={goalsPageAndBannerEnabled ? goal.attr('percentComplete') : goal.attr('status')}
        onEdit={() => {
          openModal(buildModalQuery(modalConsts.goalModal, {
            goalId: goal.id(),
          }));
        }}
        onDelete={() => { onDelete(goal); }}
        collapsed
      />
    );
  });

  return (
    <div
      className={classes.goals}
      ref={eventTrackingNodeRef}
    >
      <GoalsHeader
        count={activeGoals.length}
        title="Active Goals"
        addGoal
      />
      {ActiveGoals}
      <GoalsHeader
        count={completedGoals.length}
        title="Completed Goals"
      />
      {CompletedGoals}
    </div>
  );
};

GoalCardList.propTypes = {
  loadedGoals: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default GoalCardList;
